export const SESSION_KEY = "LogyTextSessionCookie";
